// extracted by mini-css-extract-plugin
export default {"cls1":"zhUeSzDtUEud6iDbXB08","cls2":"xTsXak8C2EZ6Vchn4vNc zhUeSzDtUEud6iDbXB08"};